module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoBAMAAAB+0KVeAAAAElBMVEWMjLMAAACepMCHh7CJiaifpsCmqoHyAAAABXRSTlMUAIkMBvw5/cUAAADESURBVCjPdZPRDYMwDEQvmAGI6ABVpf4HsQCVMkEl9l+lCRwcLsr95enZMrJB3JNnwDIfhAlbjPBgpIILzvQHHHHJVKGK1QASpUKiVMQH/vIpcHDkBYQIX92tT1iBTnyvXxQ0erHCCYMXSzkClpuInlDiBtNNhHE4iRVyOIluOIkq8yLrvJioOjFRvYiGhV0l8ouqWkTBAVTVMWAEVc04IXJWiTjX0Uk0LU4JjRXfj6F9Nl61xim2j9afd/tH2JMLnjMfPxm0Kejxy9TBAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./images/baseintrov2/check3.png
// module id = 571
// module chunks = 0